<mat-form-field class="np-mat-autocomplete"
    [class.is-invalid]="((selectControl.value && !selectedValue) || !selectControl.valid) && selectControl.touched && !isFocus"
    [class.is-valid]="(!selectControl.value || (selectControl.value && selectedValue)) && selectControl.valid && selectControl.touched && !isFocus">
    <ng-container *ngIf="selectedValue && (!isFocus || readonly)">
        <span matPrefix [class]="selectedValue.flag"></span>
        <span matPrefix>&nbsp;</span>
    </ng-container>
    <input matInput type="text" 
    [placeholder]="placeholder" 
    [formControl]="selectControl" 
    [matAutocomplete]="auto" 
    [class]="inputClass" 
    [readonly]="readonly"
    (change)="inputValueChange()" 
    (focus)="isFocus = true" 
    (blur)="isFocus = false">

    <mat-autocomplete #auto="matAutocomplete" (optionSelected)="selectControlChange($event)">
        <mat-option *ngFor="let item of filteredOptions | async" [value]="item[dataDisplayValue]">
            <span [class]="item.flag"></span>&nbsp;{{ item[dataDisplayValue] }}
        </mat-option>
    </mat-autocomplete>
</mat-form-field>

<div *ngIf="(selectControl.hasError('required') || (selectControl.value && !selectedValue)) && selectControl.touched && !isFocus" class="error-message">
    Please input valid information here
</div>